import { useEffect, useState } from "react";
import type { LatLngLiteral } from "leaflet";
import { Input } from "~/components/ui";
import LocationPickerDialog from "~/components/common/location-picker-dialog";
import type { Coordinates } from "~/types/ui";

const EMPTY_COORDINATES: Coordinates = { latitude: null, longitude: null };

export function CoordinatesFormField({
  value,
  onChange,
}: {
  value: string;
  onChange: (val: string) => void;
}) {
  const [coordinates, setCoordinates] = useState<Coordinates>(() => {
    try {
      const parsed = JSON.parse(value) as Coordinates;
      if (!parsed)
        throw new Error("Invalid JSON: parsed value is null or undefined");

      return parsed;
    } catch (e) {
      return EMPTY_COORDINATES;
    }
  });

  // sync serialized value whenever state changes
  useEffect(() => {
    onChange(JSON.stringify(coordinates));
  }, [coordinates, onChange]);

  return (
    <div className="flex gap-2">
      <Input
        type="number"
        step="any"
        placeholder="Latitude"
        value={coordinates.latitude ?? ""}
        onChange={(e) =>
          setCoordinates((prev: Coordinates) => ({
            ...prev,
            latitude: e.target.value === "" ? null : Number(e.target.value),
          }))
        }
      />
      <Input
        type="number"
        step="any"
        placeholder="Longitude"
        value={coordinates.longitude ?? ""}
        onChange={(e) =>
          setCoordinates((prev: Coordinates) => ({
            ...prev,
            longitude: e.target.value === "" ? null : Number(e.target.value),
          }))
        }
      />
      <LocationPickerDialog
        latitude={coordinates.latitude ?? undefined}
        longitude={coordinates.longitude ?? undefined}
        onChange={(cords: LatLngLiteral | null) => {
          if (cords) {
            setCoordinates({ latitude: cords.lat, longitude: cords.lng });
          }
        }}
      />
    </div>
  );
}
